export default __webpack_public_path__ + "static/media/1198.8ea04662.png";